import { render } from "./App.vue?vue&type=template&id=fb55a57e&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=fb55a57e&lang=scss&scoped=true"

import exportComponent from "/media/ctis/developer1/WorkSpaceFront/ser-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb55a57e"]])

export default __exports__